import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  quickFilter: {
    paddingBlock: 12,
    paddingInline: 20,
  },
  filterWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    rowGap: 12,
    flexWrap: 'wrap',
  },
}))

export default useStyles
